import React from "react";
import {message,AutoComplete,Row,Col,Space,Button} from "antd";
import {DragOutlined,MinusCircleOutlined,SettingOutlined,PlusOutlined,LinkOutlined} from "@ant-design/icons";
import less from "../ShowEchart.less";
import classNames from "classnames";

export default class PointDataSet extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            dataSetConfig: this.props.value || {
                mainAxisField: null,
                auxiliaryAxisField: null,
                pointSeriesArr: [],
            },
            
            listChange: 0,
            dragTreeNode: null,
            dropTreeNode: null,
        }
    }

    configChanged(){
        this.props.onChange?.(this.state.dataSetConfig);
    }

    render(){
        let {dataSetConfig,listChange} = this.state;

        let defineDragOpt = (treeNode) => {
            let opt = {};

            opt.draggable = true;
            opt.onDragStart = (e) => {
                log("开始拖拽");
                this.setState({
                    dragTreeNode: treeNode
                });
            };
            opt.onDragEnd = (e) => {
                log("结束");
                this.setState({
                    dragTreeNode: null,
                    dropTreeNode: null,
                });
            };

            opt.onDragOver = (e) => {
                e.preventDefault();
            };
            opt.onDragEnter = (e) => {
                log("进入");
                this.setState({
                    dropTreeNode: treeNode
                })
            };
            opt.onDragLeave = (e) => {
                //多一个判断，解决setState的异步更新策略导致的状态合并更新
                // if (this.state.dropTreeNode && this.state.dropTreeNode._id === treeNode._id) {
                //     this.setState({
                //         dropTreeNode: null
                //     })
                // }
            };
            opt.onDrop = (e) => {
                e.preventDefault();
                log("放下", this.state.dragTreeNode);
                log("放入", this.state.dropTreeNode);

                //重新排序
                let {dataSetConfig,listChange} = this.state;
                if (this.state.dragTreeNode.index === this.state.dropTreeNode.index) {
                    //没变
                } else {
                    let newList = [];
                    dataSetConfig.pointSeriesArr.forEach((item,index) => {
                        if (index === this.state.dropTreeNode.index) {
                            newList.push(this.state.dropTreeNode);
                            newList.push(this.state.dragTreeNode);
                        } else if (item.index === this.state.dragTreeNode.index) {
                            //不要了
                        } else {
                            newList.push(item);
                        }

                    });
                    dataSetConfig.pointSeriesArr = newList;
                }

                //释放
                this.setState({
                    dragTreeNode: null,
                    dropTreeNode: null,
                    dataSetConfig: dataSetConfig,
                    listChange: listChange + 1
                },()=>{
                    this.configChanged()
                })
            };

            return opt;
        };

        return <div>
            <Row>
                <Col span={6} offset={2}>主轴属性：</Col>
                <Col span={10}>
                    <AutoComplete
                        size={"small"}
                        style={{width: "100%"}}
                        value={dataSetConfig?.mainAxisField}
                        placeholder={"请选择或填写对接字段"}
                        options={this.props.optionsForAxis}
                        onChange={(v)=>{
                            dataSetConfig.mainAxisField = v;
                            this.setState({},()=>{
                                this.configChanged()
                            })
                        }}
                    />
                </Col>
                <Col span={16} offset={8} style={{opacity: 0.5}}>若不设置，默认作为数值轴</Col>
            </Row>
            <Row>
                <Col span={6} offset={2}>辅轴属性：</Col>
                <Col span={10}>
                    <AutoComplete
                        size={"small"}
                        style={{width: "100%"}}
                        value={dataSetConfig?.auxiliaryAxisField}
                        placeholder={"请选择或填写对接字段"}
                        options={this.props.optionsForAxis}
                        onChange={(v)=>{
                            dataSetConfig.auxiliaryAxisField = v;
                            this.setState({},()=>{
                                this.configChanged()
                            })
                        }}
                    />
                </Col>
                <Col span={16} offset={8} style={{opacity: 0.5}}>若不设置，默认作为数值轴</Col>
            </Row>
            {
                dataSetConfig?.pointSeriesArr?.map((eachLineSet,index)=>{
                    eachLineSet.index = index;
                    return <Row
                        {...defineDragOpt(eachLineSet)}
                        key={"la" + index + listChange}
                        className={classNames({
                            [less.tabLine]: true,
                            [less.dropTreeHover]: this.state.dropTreeNode && this.state.dropTreeNode.index === index
                        })}
                    >
                        <Col span={2}><DragOutlined /></Col>
                        <Col span={6}>
                            系列{index + 1}属性：</Col>
                        <Col span={10}>
                            <AutoComplete
                                size={"small"}
                                style={{width: "100%"}}
                                value={eachLineSet.field}
                                placeholder={"请选择或填写对接字段"}
                                options={this.props.options}
                                onChange={(v)=>{
                                    eachLineSet.field = v;
                                    this.setState({},()=>{
                                        this.configChanged()
                                    })
                                }}
                            />
                        </Col>
                        <Col span={5} offset={1}>
                            <Space>
                                <MinusCircleOutlined
                                    style={{
                                        color: "red"
                                    }}
                                    onClick={()=>{
                                        this.deleteLine(index)
                                    }}
                                />
                            </Space>
                        </Col>
                    </Row>
                })
            }
            <Row>
                <Col span={6} offset={4}>
                    <Button
                        icon={<LinkOutlined />}
                        type={"link"}
                        size={"small"}
                        onClick={()=>{
                            this.addAll()
                        }}
                    >
                        自动提取
                    </Button>
                </Col>
                <Col span={6} offset={4}>
                    <Button
                        icon={<PlusOutlined />}
                        style={{color: "limegreen"}}
                        type={"link"}
                        size={"small"}
                        onClick={()=>{
                            this.addOneLineData()
                        }}
                    >
                        增加一个系列
                    </Button>
                </Col>
            </Row>
        </div>
    }


    addOneLineData(){
        let {dataSetConfig} = this.state;

        if(!dataSetConfig.pointSeriesArr){
            dataSetConfig.pointSeriesArr = [];
        }

        dataSetConfig.pointSeriesArr.push({
            field: null,
            extraStyle: null,
        })

        this.setState({})
    }

    deleteLine(index){
        let {dataSetConfig,listChange} = this.state;

        _.remove(dataSetConfig.pointSeriesArr,(ti,n)=>{
            return n === index
        })

        this.setState({listChange: listChange + 1},()=>{
            this.configChanged()
        })
    }

    addAll(){
        let {dataSetConfig} = this.state;

        if(!dataSetConfig.pointSeriesArr){
            dataSetConfig.pointSeriesArr = [];
        }

        let has = [];
        dataSetConfig?.pointSeriesArr?.forEach((lineSet)=>{
            has.push(lineSet.field);
        })
        this.props.options?.forEach((opt)=>{
            if(!has.includes(opt.value)){
                dataSetConfig.pointSeriesArr.push({
                    field: opt.value,
                    extraStyle: null,
                })
            }
        })

        this.setState({},()=>{
            this.configChanged()
        })
    }
}